import { html } from 'lit';
import { SendHorizontal } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-send-horizontal')
export class PdsIconSendHorizontal extends PdsIcon {
  @state()
  icon = SendHorizontal;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
